import { Translation } from './translation';

const commonTranslations: Translation[] = [
  { id: 'userNotifications.error.error', nb: '[!] Error', en: 'Error' },
  {
    id: 'userNotifications.error.sthWentWrong',
    nb: 'Noe gikk galt',
    en: 'Something went wrong',
  },
  {
    id: 'userNotifications.notFound.error',
    nb: 'Objekt mangler',
    en: 'Object missing',
  },
  {
    id: 'userNotifications.notFound.notFound',
    nb: 'Sider eller objekt ikke funnet',
    en: 'Page or object not found',
  },
  {
    id: 'userNotifications.permissions.error',
    nb: 'Manglende rettigheter',
    en: 'Permissions missing',
  },
  {
    id: 'userNotifications.permissions.invalidInput',
    nb: 'Du har ikke rettigheter til å gjøre det',
    en: "You're not authorized to do that",
  },
  {
    id: 'userNotifications.systemOffline.offline',
    nb: 'Systemet er offline',
    en: 'System offline',
  },
  {
    id: 'userNotifications.systemOffline.tryAgain',
    nb: 'Prøv igjen senere',
    en: 'Please try again in a while',
  },
  { id: 'userNotifications.validation.error', nb: 'Error', en: 'Error' },
  {
    id: 'userNotifications.validation.invalidInput',
    nb: 'Ugyldig input',
    en: 'Invalid input',
  },
  { id: 'userNotifications.warning.warning', nb: 'Warning', en: 'Warning' },
  {
    id: 'userNotifications.warning.areYouSure',
    nb: 'Er du sikker på at du vil fortsette',
    en: 'Are you sure you want to proceed?',
  },
];

export default commonTranslations;
